var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumbleiconsChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    fill: "none",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.166 43.542l-2.13-.848a2.292 2.292 0 002.577 3.094l-.447-2.246zm10.785-2.145l1.086-2.02-.726-.389-.807.16.447 2.249zm-7.063-7.212l2.131.848.374-.949-.45-.914-2.055 1.015zM43.541 27.5c0 7.439-6.538 13.75-14.964 13.75v4.583c10.635 0 19.548-8.052 19.548-18.333H43.54zm-29.926 0c0-7.439 6.54-13.75 14.964-13.75V9.167c-10.636 0-19.55 8.053-19.55 18.333h4.585zm14.964-13.75c8.424 0 14.962 6.311 14.962 13.75h4.584c0-10.28-8.91-18.333-19.546-18.333v4.583zm-.002 27.5c-2.762 0-5.333-.687-7.54-1.872l-2.172 4.035a20.387 20.387 0 009.712 2.42V41.25zM9.613 45.788l10.785-2.145-.894-4.494-10.785 2.145.894 4.496v-.002zm5.33-12.618a12.83 12.83 0 01-1.329-5.67H9.03c0 2.75.646 5.358 1.801 7.7l4.114-2.03zm-4.184.167l-3.724 9.36 4.258 1.69 3.722-9.356-4.258-1.694h.002zM20.625 29.792a2.292 2.292 0 100-4.583 2.292 2.292 0 000 4.583zM28.645 29.792a2.292 2.292 0 100-4.583 2.292 2.292 0 000 4.583zM36.667 29.792a2.292 2.292 0 100-4.583 2.292 2.292 0 000 4.583z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumbleiconsChat);
export default ForwardRef;